import React from "react";
import WinLogo from "../../assets/images/win/logo-win.svg";
import CustomDropdown from "../../CustomControls/dropdownnn";
import FamilyImage from "../../assets/images/enrollmet1.png";
import { set } from "date-fns";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints"; 
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPartiallyVerified } from "../../Redux/verificationReducer";
import ErrorModal from "../Security/ErrorModal";
import { useState } from "react";

const Eligibilityform = () => {
  const location = useLocation(); 
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalMessage, setModalMessage] = React.useState("");
const nameRegex = /^[A-Za-z .'_\-]{3,20}$/; // alphabets, spaces, hyphens, apostrophes, periods, underscores, min 3, max 20
  const [showModal, setShowModal] = React.useState(false);
  const [selectedRelation, setSelectedRelation] = React.useState("");
  const [employeeId, setEmployeeId] = React.useState("");
  const [employeeFirstName, setEmployeeFirstName] = React.useState("");
  const [employeeLastName, setEmployeeLastName] = React.useState("");
  const createAccountParams = location.state?.combinedDataMemberId || {};
  const contractlist = location.state?.contractlist || [];
  const selectedContract = location.state?.selectedContract || "";
  const memberId = location.state?.memberId || "";
  const [loading, setLoading] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [result, setResult] = React.useState(null);
  // Validation state
  const [errors, setErrors] = React.useState({
    employeeId: "",
    employeeFirstName: "",
    employeeLastName: "",
    selectedRelation: "",
  });

  // autopopulate employee info if coming from contracts form or updatedFormData
  React.useEffect(() => {
    // If coming from contracts, also check updatedFormData for values
    if (location.state?.combinedDataMemberId) {
      const data = location.state.combinedDataMemberId;
      if (data.EmployeeID) setEmployeeId(data.EmployeeID);
      if (data.EmployeeFirstName) setEmployeeFirstName(data.EmployeeFirstName);
      if (data.EmployeeLastName) setEmployeeLastName(data.EmployeeLastName);
      if (data.RelationshiptoEmployee) setSelectedRelation(data.RelationshiptoEmployee);
    }
  }, [location.state]);

  const handleRelationChange = (value) => {
    setSelectedRelation(value);
    // Clear error on change
    setErrors((prev) => ({ ...prev, selectedRelation: "" }));
  };

  const handleEmployeeIdChange = (e) => {
    setEmployeeId(e.target.value);
    if (e.target.value?.trim()) {
      setErrors((prev) => ({ ...prev, employeeId: "" }));
    }
  };

  const handleEmployeeFirstNameChange = (e) => {
    const val = e.target.value;
    setEmployeeFirstName(val);
    // live validation
    if (!val.trim()) {
      setErrors((prev) => ({ ...prev, employeeFirstName: "This field is required" }));
    } else if (!nameRegex.test(val.trim())) {
      setErrors((prev) => ({ ...prev, employeeFirstName: "Please enter valid First Name" }));
    } else {
      setErrors((prev) => ({ ...prev, employeeFirstName: "" }));
    }
  };

  const handleEmployeeLastNameChange = (e) => {
    const val = e.target.value;
    setEmployeeLastName(val);
    // live validation
    if (!val.trim()) {
      setErrors((prev) => ({ ...prev, employeeLastName: "This field is required" }));
    } else if (!nameRegex.test(val.trim())) {
      setErrors((prev) => ({ ...prev, employeeLastName: "Please enter valid Last Name" }));
    } else {
      setErrors((prev) => ({ ...prev, employeeLastName: "" }));
    }
  };

  const validateForm = () => {
    const firstNameErr = !employeeFirstName?.trim()
      ? "This field is required"
      : !nameRegex.test(employeeFirstName.trim())
      ? "Please enter valid First Name"
      : "";

    const lastNameErr = !employeeLastName?.trim()
      ? "This field is required"
      : !nameRegex.test(employeeLastName.trim())
      ? "Please enter valid Last Name"
      : "";

    const newErrors = {
      employeeId: employeeId?.trim() ? "" : "This field is required",
      employeeFirstName: firstNameErr,
      employeeLastName: lastNameErr,
      selectedRelation: selectedRelation ? "" : "This field is required",
    };
    setErrors(newErrors);
    return Object.values(newErrors).every((val) => !val);
  };
  const handleBack = () => {
    debugger
    const updated = {
      ...createAccountParams,
      EmployeeID: employeeId,
      EmployeeFirstName: employeeFirstName,
      EmployeeLastName: employeeLastName,
      RelationshiptoEmployee: selectedRelation,
     
    };
    // Pass contractlist as apiResponse, and also pass selectedContract and memberId for autopopulation
    navigate("/contracts", {
      state: {
        updatedFormData: updated,
        apiResponse: contractlist,
      selectedContract,
      memberId
      }
    });
  }
  const createAccount = async() => {
      // Client-side validation before submitting
      const isValid = validateForm();
      if (!isValid) {
        return;
      }
      createAccountParams.WhyHere = "I want family-building support";

      const updatedFormData = {
          ...createAccountParams,
          amount: 0,
          EmployeeID: employeeId,
          EmployeeFirstName: employeeFirstName,
          EmployeeLastName: employeeLastName,
          RelationshiptoEmployee: selectedRelation
      };
      setLoading(true);
              // Make the API call
              try {
                setLoading(true);
                setIsSubmitting(true);
                const response = await axios.post(
                  Endpoints.CreateAccount,
                  null,
                  {
                    params: { _Params: JSON.stringify(updatedFormData) },
                  }
                );
                if (response.data) {
                  setResult(response.data.Result);
                  setShowModal(true);
                  setModalMessage(response.data.Message);
                } else {
                  console.error("Unexpected response format:", response);
                }
              } catch (error) {
                console.error("API Error:", error);
              } finally {
                setIsSubmitting(false);
                setLoading(false);
              }
    }

  return (
    <>
    {loading && (
        <div className="loading-container">
          <div className="loading"></div>        
          <h2 className="loading-text">{"loading"}</h2>
        </div>
      )}

      {/* HEADER */}
      <header>
        <nav className="navbar navbar-expand-lg container-fixed">
          <a className="navbar-brand" href="#">
            <img src={WinLogo} alt="WIN Logo" className="logo brand-logo" />
          </a>
        </nav>
      </header>

      <div className="paymentstep-page-wrapper">
        <div className="paymentstep-centered-container">
          <div className="registration-block-main patient-consent-screen paymentstep-wrapper">

            {/* Back Button */}
            <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
              <button onClick={()=>handleBack()} className="win-back-btn">
                <span>
                  <i className="bi bi-chevron-left"></i> Back
                </span>
              </button>
            </div>

            {/* CONTENT */}
            <div className="registration-form-main mt-2 paymentstep-form">
              <div className="registration-form payment-wrapper">
                <div className="registration-process-form-wrapper">

                  {/* TITLE */}
                  <h2 className="page-heading-primaryy mt-4">
                    We just need a few more<br />
                    details to verify your eligibility.
                  </h2>

                  <p className="text-mute mt-3">
                    Please provide the following information so we can connect you
                    to your WIN benefits.
                  </p>

                  {/* MOBILE BACKGROUND IMAGE FORM BLOCK */}
                  <div className="eligibility-form-wrapper mt-1">

                    {/* Background Image (mobile only) */}
                    <div
                      className="eligibility-form-bg mobile-only"
                      style={{ backgroundImage: `url(${FamilyImage})` }}
                    ></div>

                    {/* Gradient Overlay */}
                    <div className="eligibility-form-overlay mobile-only"></div>

                    {/* FORM FIELDS */}
                    <div className="eligibility-form-content">
                      
                      <div className="form-group mt-3">
                        <input
                          type="text"
                          placeholder="Employee ID"
                          value={employeeId}
                          onChange={handleEmployeeIdChange}
                          className="win-form-control mobile-view"
                        />
                        {errors.employeeId && (
                          <div className="text-danger small mt-1">{errors.employeeId}</div>
                        )}
                      </div>

                      <div className="form-group mt-3">
                        <input
                          type="text"
                          placeholder="Employee First Name"
                          value={employeeFirstName}
                          onChange={handleEmployeeFirstNameChange}
                          className="win-form-control mobile-view"
                          maxLength={20}
                        />
                        {errors.employeeFirstName && (
                          <div className="text-danger small mt-1">{errors.employeeFirstName}</div>
                        )}
                      </div>

                      <div className="form-group mt-3">
                        <input
                          type="text"
                          placeholder="Employee Last Name"
                          value={employeeLastName}
                          onChange={handleEmployeeLastNameChange}
                          className="win-form-control mobile-view"
                          maxLength={20}
                        />
                        {errors.employeeLastName && (
                          <div className="text-danger small mt-1">{errors.employeeLastName}</div>
                        )}
                      </div>

                      <div className="form-group mt-3">
                        <CustomDropdown
                         selectedOption={selectedRelation}
                          onChange={(value)=> {handleRelationChange(value)}}
                          className="win-form-control mobile-view"
                          options={[
                                 "Self",
                                 "Spouse",
                                 "Dependent"
                     ]}
                        />
                        {errors.selectedRelation && (
                          <div className="text-danger small mt-1">{errors.selectedRelation}</div>
                        )}
                      </div>

                    </div>
                  </div>

                 {/* PROGRESS + BUTTON LEFT ALIGNED */}
                    <div className="eligibility-left-block mt-3">

                     {/* PROGRESS BAR */}
                    <div className="progress-dash-bar eligibility-progress-left">
                     <div className="dash"></div>
                        <div className="dash"></div>
                        <div className="dash"></div>
                    <div className="dash  active"></div>
                    <div className="dash"></div>
                    </div>

  {/* NEXT BUTTON */}
  <div className="eligibility-next-left mt-4">
    <button onClick={createAccount} className="win-btn-primaryy w-100">Next</button>
  </div>

</div>

                </div>
              </div>
            </div>
            <ErrorModal show={showModal} message={modalMessage} isOkay={true} 
            onOkay={() => {
              setShowModal(false);
              if(result === 2){
                navigate("/home");
              } else if(result === 0){
                navigate("/login");
              }  
            }}/>

          </div>
        </div>
      </div>
    </>
  );
};

export default Eligibilityform;
